// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__219Ey","rootSmall":"AddTileButton_rootSmall__3rNKL"};